import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M25 0C25.8333 0 26.5417 0.291667 27.125 0.875C27.7083 1.45833 28 2.16667 28 3V32L16 25L4 32V3C4 2.16667 4.29167 1.45833 4.875 0.875C5.45833 0.291667 6.16667 0 7 0H25ZM26 28.5V3C26 2.70833 25.8958 2.47917 25.6875 2.3125C25.5208 2.10417 25.2917 2 25 2H7C6.70833 2 6.45833 2.10417 6.25 2.3125C6.08333 2.47917 6 2.70833 6 3V28.5L16 22.6875L26 28.5Z'],
  name: 'uiBookmark',
  oldName: 'falBookmark'
} as IconDefinition
